"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryMove = exports.worldCoordToScreenCoord = exports.screenCoordToWorldCoord = exports.isCoordInWorld = void 0;
const euclid_1 = require("@reality/euclid");
function worldCoordToScreenCoord(worldCoord, centerCoord, { viewportWidth, viewportHeight }) {
    return euclid_1.CoordinateUtils.subtract(euclid_1.CoordinateUtils.add(worldCoord, {
        x: viewportWidth / 2,
        y: viewportHeight / 2,
    }), centerCoord);
}
exports.worldCoordToScreenCoord = worldCoordToScreenCoord;
/**
 * TODO: refactor as screenPixelToWorldCoord
 *
 * @param screenCoord
 * @param centerCoord
 */
function screenCoordToWorldCoord(screenCoord, centerCoord, { viewportWidth, viewportHeight }) {
    return euclid_1.CoordinateUtils.subtract(euclid_1.CoordinateUtils.add(screenCoord, centerCoord), {
        x: viewportWidth / 2,
        y: viewportHeight / 2,
    });
}
exports.screenCoordToWorldCoord = screenCoordToWorldCoord;
function isCoordInWorld(coord, region) {
    if (coord.x < 0 || coord.y < 0) {
        return false;
    }
    if (coord.x >= region.width || coord.y >= region.height) {
        return false;
    }
    return true;
}
exports.isCoordInWorld = isCoordInWorld;
/**
 * Returns the coords of the new location if the player can move, otherwise returns false
 * @param {*} player
 * @param {*} worldData
 */
function tryMove(position, region, direction) {
    let newCoords = euclid_1.CoordinateUtils.add(position, euclid_1.COORDINATE_DELTAS[direction]);
    if (isTileWalkable(newCoords, region)) {
        return newCoords;
    }
    else {
        return false;
    }
}
exports.tryMove = tryMove;
function isTileWalkable(coord, region) {
    if (coord.x < 0 || coord.y < 0) {
        return false;
    }
    if (coord.x >= region.map.length || coord.y >= region.map[0].length) {
        return false;
    }
    // TODO: implement full support for directional collision
    return !region.map[coord.x][coord.y].collision;
}
//# sourceMappingURL=region-utils.js.map